import {NDVSClient} from "../../client/NDVSClient";
import {getStationCode} from "../../util/NetworkUtil";

export function printTransferSheet(scannableIds, dispatcher) {
    NDVSClient.printTransferSheet({
       shipments : scannableIds,
       stationCode : getStationCode(),
    }).then(({valid, data}) => {
        if (valid) {
            const base64String = data.transferSheetPdf;
            const blob = base64toBlob(base64String);

            const fileURL = URL.createObjectURL(blob);
            window.open(fileURL);
            dispatcher({
                type: "PRINT_TRANSFER_SHEET_RESPONSE"
            })
        }
    });
}

const base64toBlob = (base64WithoutPrefix) => {
    const bytes = atob(base64WithoutPrefix);
    let length = bytes.length;
    let out = new Uint8Array(length);

    while (length--) {
        out[length] = bytes.charCodeAt(length);
    }
    return new Blob([out], { type: 'application/pdf' });
};




// WEBPACK FOOTER //
// ./src/components/transferSheet/network/PrintTransferSheetAPI.js